import { pick } from 'lodash';
import Quill from 'quill';

import {
  addLinkStyle,
  addMailtoStyle,
} from 'hb-react/shared/components/DesignSystem/QuillEditor/utils/addLinkStyle';

const Clipboard = Quill.import('modules/clipboard');
const Delta = Quill.import('delta');

class BetterClipboard extends Clipboard {
  static moduleName = 'clipboard';

  onPaste(e) {
    e.preventDefault();

    let concatDelta = null;

    const html = e.clipboardData.getData('text/html');

    if (html && html.trim() !== '') {
      const deltaFromHtml = this.quill.clipboard
        .convert(html)
        .ops.map(({ attributes, ...op }) => ({
          ...op,
          // Only keep attributes that are available in the editor
          attributes: pick(attributes, this.options.attributes),
        }));

      concatDelta = new Delta(deltaFromHtml);
    } else {
      const plainText = e.clipboardData.getData('text');

      concatDelta = new Delta().insert(plainText);
    }

    let ops = addLinkStyle(concatDelta.ops);

    ops = addMailtoStyle(ops);

    const newDelta = new Delta(ops);

    const range = this.quill.getSelection();
    const delta = new Delta()
      .retain(range.index)
      .delete(range.length)
      .concat(newDelta);

    this.quill.updateContents(delta, Quill.sources.SILENT);
    this.quill.setSelection(
      delta.length() - range.length,
      0,
      Quill.sources.SILENT,
    );
    this.quill.scrollIntoView();
  }
}

export default BetterClipboard;
